import React, { useEffect, useRef } from "react";
import { motion, useInView, useAnimation } from "framer-motion";

export default function LoadAnim({ children, className }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const mainControls = useAnimation();
  const slideControls = useAnimation();

  useEffect(() => {
    if (isInView) {
      slideControls.start("visible");
      mainControls.start("visible");
    }
  }, [isInView, mainControls, slideControls]); // Add mainControls and slideControls as dependencies

  return (
    <div
      ref={ref}
      className={`${className} w-[fit-content] relative overflow-hidden`}
    >
      <motion.div
        variants={{
          hidden: { left: "-30%" },
          visible: { left: "100%" },
        }}
        initial="hidden"
        animate={slideControls}
        className="absolute top-[10px] bottom-[0] left-0 right-0 bg-[#0a0a0d] z-[20]"
        transition={{ duration: 0.7, ease: "easeIn", delay: 0.3 }}
      ></motion.div>
      <motion.div
        variants={{
          hidden: { opacity: 0, y: 75 },
          visible: { opacity: 1, y: 0 },
        }}
        initial="hidden"
        animate={mainControls}
        transition={{ duration: 0.5, delay: 0.6 }}
      >
        {children}
      </motion.div>
    </div>
  );
}
